import { render, staticRenderFns } from "./evaluations.component.vue?vue&type=template&id=ab744132&scoped=true&"
import script from "./evaluations.component.vue?vue&type=script&lang=js&"
export * from "./evaluations.component.vue?vue&type=script&lang=js&"
import style0 from "./evaluations.component.vue?vue&type=style&index=0&id=ab744132&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab744132",
  null
  
)

export default component.exports